module.exports = __webpack_public_path__ + "static/media/invited.70b6005e.svg";